import React, { createContext, useContext, useState, useEffect } from "react";
import client from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [selectedId, setSelectedId] = useState(localStorage.getItem("md_prop") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || user.role === "guest") { setLoading(false); return; }
    client.get("/properties").then((r) => {
      setProperties(r.data);
      setSelectedId((prev) => {
        const valid = r.data.find((p) => p.id === prev);
        return valid ? prev : r.data[0]?.id || null;
      });
    }).finally(() => setLoading(false));
  }, [user]);

  useEffect(() => { if (selectedId) localStorage.setItem("md_prop", selectedId); }, [selectedId]);

  const selected = properties.find((p) => p.id === selectedId) || null;

  return (
    <PropertyContext.Provider value={{ properties, selected, selectedId, setSelectedId, loading }}>
      {children}
    </PropertyContext.Provider>
  );
}

export function useProperty() {
  return useContext(PropertyContext);
}
